import { createAsyncThunk } from "@reduxjs/toolkit";
import payrollServiceApiInstance from "../../../../../../config/payrollApiConfig";
import {EsicMonthlyContribution,CreateEsicMonthlyContributionPayload,UpdateEsicMonthlyContributionPayload} from "./esicMonthlyContributionTypes";

// Create
export const createEsicMonthlyContribution = createAsyncThunk<
  { id: number },
  CreateEsicMonthlyContributionPayload
>("esicMonthlyContribution/create", async (payload, { rejectWithValue }) => {
  try {
    const response = await payrollServiceApiInstance.post("/esic-contribution", payload);
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Get All
export const fetchEsicMonthlyContributionList = createAsyncThunk<
  EsicMonthlyContribution[]>("esicMonthlyContribution/fetchAll", async (_, { rejectWithValue }) => {
  try {
    const response = await payrollServiceApiInstance.get("/esic-contribution");
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Get By Id
export const fetchEsicMonthlyContributionById = createAsyncThunk<
  EsicMonthlyContribution,
  number
>("esicMonthlyContribution/fetchById", async (id, { rejectWithValue }) => {
  try {
    const response = await payrollServiceApiInstance.get(`/esic-contribution/${id}`);
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Update
export const updateEsicMonthlyContribution = createAsyncThunk<
  void,
  { id: number; payload: UpdateEsicMonthlyContributionPayload }
>("esicMonthlyContribution/update", async ({ id, payload }, { rejectWithValue }) => {
  try {
    await payrollServiceApiInstance.put(`/esic-contribution/${id}`, payload);
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Delete
export const deleteEsicMonthlyContribution = createAsyncThunk<void, number>(
  "esicMonthlyContribution/delete",
  async (id, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/esic-contribution/${id}`);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
